import React from 'react';
import css from './ReportsV2ListIntensity.module.scss';
import classNames from 'classnames';

type ReportIntensityLevel =
  | 'Tranquil'
  | 'Chill'
  | 'Calm'
  | 'Steady'
  | 'Lively'
  | 'Exciting'
  | 'Thrilling'
  | 'Exhilarating'
  | 'Extreme'
  | 'HEART STOPPING';

const REPORT_INTENSITY_LEVELS: ReportIntensityLevel[] = [
  'Tranquil',
  'Chill',
  'Calm',
  'Steady',
  'Lively',
  'Exciting',
  'Thrilling',
  'Exhilarating',
  'Extreme',
  'HEART STOPPING',
];

const REPORT_INTENSITY_COLORS = [
  '#4E75F5',
  '#4E75F5',
  '#27BACC',
  '#27BACC',
  '#FFC52F',
  '#FFC52F',
  '#FF6D2F',
  '#FF6D2F',
  '#FF3122',
  '#FF3122',
];

export const getIntensityLevel = (intensity: number) =>
  Math.min(Math.max(0, Math.floor((intensity - 1) / 10)), 9);

export const getIntensityLabel = (intensity: number) =>
  REPORT_INTENSITY_LEVELS[getIntensityLevel(intensity)];

export const getIntensityColor = (intensity: number) =>
  REPORT_INTENSITY_COLORS[getIntensityLevel(intensity)];

export const ReportsV2IntensityIcon = ({
  intensity,
  width = 40,
  className,
}: {
  intensity: number;
  width?: number;
  className?: string;
}) => {
  return (
    <svg
      className={classNames(css.intensityIcon, className)}
      width={width}
      height={4}
      viewBox={`0 0 ${width} 4`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id="paint0_linear_168_145"
          x1="0"
          y1="2"
          x2={width}
          y2="2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2929AC" />
          <stop offset="0.2501" stopColor="#29A4AC" />
          <stop offset="0.5" stopColor="#FFC52F" />
          <stop offset="0.7501" stopColor="#FF6D2F" />
          <stop offset="1" stopColor="#FF3122" />
        </linearGradient>
      </defs>

      <path
        d={`M2 2 L${width - 2} 2`}
        stroke="#47474f"
        strokeWidth="4"
        strokeLinecap="round"
      />

      <path
        d={`M2 2 L${width - 2} 2`}
        stroke="url(#paint0_linear_168_145)"
        strokeWidth="4"
        strokeLinecap="round"
        style={{
          strokeDasharray: width,
          strokeDashoffset: `${width - intensity * (width / 100)}`,
        }}
      />
    </svg>
  );
};

export const ReportsV2ListIntensity = ({intensity}: {intensity: number}) => {
  return (
    <div className={css.intensityStats}>
      <ReportsV2IntensityIcon intensity={intensity} />

      <div className={css.intensityText}>
        <span
          className={css.intensityValueText}
          style={{color: getIntensityColor(intensity)}}
        >
          {getIntensityLabel(intensity)}
        </span>
        {' intensity'}
      </div>
    </div>
  );
};
